<template>
	<div id="alert" v-if="alertSet" class="alert alert-dismissible show" v-bind:class="variant?'alert-'+variant: 'alert-primary'" role="alert">
		{{alert}}
		<button v-on:click="close" type="button" class="close" data-dismiss="alert" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
</template>
<script>
export default {
	created: function(){
		this.alertSet = this.alert;
	},
	data: function(){
		return {
			alertSet:null,
		}
	},
	props:{
		alert:{
			type:String
		},
		handleClose:{
			type:Function
		},
		variant:{
			type:String
		},
	},
	methods:{
		close:function(){
			this.alertSet = null;
			if (this.handleClose) this.handleClose();
		}
	},
	watch:{
		alert:function(newAlert){
			this.alertSet = newAlert;
		}
	}
}
</script>

<style>
	#alert{
		z-index:1011;
	}
</style>


// WEBPACK FOOTER //
// src/components/content/content-alert.vue